const Archived = () => {
  return <></>;
};

export default Archived;
